import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  ref: "canvasRef",
  class: "continuous-globe__canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["continuous-globe", { 'continuous-globe--active': _ctx.active }]),
    style: _normalizeStyle(_ctx.globeStyle),
    "aria-hidden": "true"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "continuous-globe__halo continuous-globe__halo--outer" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "continuous-globe__halo continuous-globe__halo--inner" }, null, -1)),
    _createElementVNode("img", {
      class: "continuous-globe__source",
      src: _ctx.globeImageSrc,
      alt: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("canvas", _hoisted_2, null, 512)
  ], 6))
}